<template>
  <v-app>
    <Header v-if="isLoggedIn"/>
    <Popup />

    <!-- Login page - rendered without v-container wrapper -->
    <router-view v-if="isLoginPage" />

    <!-- All other pages - rendered with standard layout -->
    <v-container v-else>
      <v-row no-gutters justify="center">
        <v-col xs="12" md="12" :lg="isCustomerDetailsLicenses ? 12 : 8" :xl="isCustomerDetailsLicenses ? 12 : 6">
          <router-view/>
        </v-col>
      </v-row>
    </v-container>

    <div v-show="showLoading" class="loading">
      <v-progress-circular indeterminate color="primary"/>
    </div>

    <!-- Dialog for update notifications -->
    <v-dialog
      v-model="showUpdateSnackbar"
      persistent
      max-width="500px"
    >
      <v-card>
        <v-card-title class="text-h5">
          Application Update
        </v-card-title>
        <v-card-text>
          New application version available. Please refresh to get the latest features and improvements.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="refreshApp"
          >
            Refresh
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import Header from './components/Header.vue';
import store from './store';
import Popup from './components/Popup.vue';
// Import version checker functions
import {
  initializeVersionChecker,
  onUpdateAvailable,
  cleanupVersionChecker,
} from './services/versionChecker';

export default {
  components: { Popup, Header },
  data() {
    return {
      axios: this.$http,
      showUpdateSnackbar: false,
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters['auth/isLoggedIn'];
    },
    isSuperuser() {
      return this.$store.getters['auth/isSuperuser'];
    },
    showLoading() {
      return store.state.loadingCounter;
    },
    isCustomerDetailsLicenses() {
      return this.$route.name === 'customerdetailslicenses';
    },
    isLoginPage() {
      return this.$route.path === '/login';
    },
  },
  methods: {
    logout() {
      const axios = this.$http;
      this.$store.dispatch('auth/logout', { axios }).then(() => {
        this.$router.push('/login');
      });
    },
    // Add this method to reload the page
    refreshApp() {
      window.location.reload(true);
    },
  },
  created() {
    // Initialize the version checker
    initializeVersionChecker();
    // Register a handler to show the snackbar when an update is available
    onUpdateAvailable(() => {
      this.showUpdateSnackbar = true;
    });
  },
  beforeDestroy() {
    // Clean up listeners when the app is destroyed
    cleanupVersionChecker();
  },
};
</script>

<style lang="scss">
@font-face {
  font-family: 'Roboto';
  src: local('Roboto'), url(./assets/fonts/Roboto-Thin.ttf) format('truetype');
  font-weight: 100; // thin
  font-style: normal;
}
@font-face {
  font-family: 'Roboto';
  src: local('Roboto'), url(./assets/fonts/Roboto-Light.ttf) format('truetype');
  font-weight: 300; // light
  font-style: normal;
}
@font-face {
  font-family: 'Roboto';
  src: local('Roboto'), url(./assets/fonts/Roboto-Regular.ttf) format('truetype');
  font-weight: 400; // regular
  font-style: normal;
}
@font-face {
  font-family: 'Roboto';
  src: local('Roboto'), url(./assets/fonts/Roboto-Medium.ttf) format('truetype');
  font-weight: 500; // medium
  font-style: normal;
}
@font-face {
  font-family: 'Roboto';
  src: local('Roboto'), url(./assets/fonts/Roboto-Bold.ttf) format('truetype');
  font-weight: 700; // bold
  font-style: normal;
}
@font-face {
  font-family: 'Roboto';
  src: local('Roboto'), url(./assets/fonts/Roboto-Black.ttf) format('truetype');
  font-weight: 900; // black
  font-style: normal;
}

@import "assets/scss/index";
</style>
